import { useEffect } from 'react';
import Lenis from 'lenis';

/**
 * LenisProvider — initialises Lenis smooth scroll for the whole page.
 * Lenis intercepts native scroll events and replaces them with a buttery,
 * physics-driven scroll. It's compatible with Framer Motion whileInView.
 *
 * Usage: render <LenisProvider /> once near the root of your app.
 */
const LenisProvider = () => {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // expo ease-out
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      smoothTouch: false, // keep native momentum on mobile
      touchMultiplier: 2,
    });

    // Sync Lenis with requestAnimationFrame for smooth rendering
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    const rafId = requestAnimationFrame(raf);

    // Expose lenis on window so other components can call lenis.scrollTo()
    window.__lenis = lenis;

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return null;
};

export default LenisProvider;
